import { Component, OnInit } from '@angular/core';
import { ENDPROCESS, LOCALSTORAGEVARS, LogTypes } from 'src/app/core/enums/enums';

@Component({
  selector: 'app-final-process',
  templateUrl: './final-process.component.html',
  styleUrls: ['./final-process.component.scss']
})
export class FinalProcessComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    this.setEndProcessOnSalesForce();
  }

  setEndProcessOnSalesForce() {
    window.sessionStorage.setItem(ENDPROCESS.endProcessOnSalesForce, JSON.stringify(true));
    this.clearVoluntaryAndInvoluntaryFlows();
  }

  clearVoluntaryAndInvoluntaryFlows() {
    window.localStorage.removeItem(LogTypes.VoluntaryChange);
    window.localStorage.removeItem(LogTypes.InvoluntaryChange);
    window.localStorage.removeItem(LOCALSTORAGEVARS.FormExchanges);
  }
}
